<template>
  <div class="side-bar">
    <ul>
			<li>
				<router-link :to="{ name: 'user_list' }" exact>ユーザ一覧</router-link>
			</li>
			<li>
				<router-link :to="{ name: 'sitter_list' }" exact>シッター一覧</router-link>
			</li>
			<li>
				<router-link :to="{ name: 'notice_list' }" exact>お知らせ</router-link>
			</li>
			<li>
				<router-link :to="{ name: 'user_report_list' }" exact>報告</router-link>
			</li>
			<li>
				<a @click="logout" exact>ログアウト</a>
			</li>
    </ul>
  </div>
</template>
<script>
import apiClient from '../../backend'

export default {
  methods: {
  },
  data () {
    return {
    }
  },
  components: {
  },
  mounted () {
  },
  methods: {
    logout() {
      apiClient.logout().then(response => {
        console.log(response)
      })
      this.$router.replace({ name: 'login' })
    }
  },
}
</script>
